import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';

export default function ShowSubtasksCheckbox({
  checked,
  onCheckedChange,
  id = 'show-subtasks',
  label = 'Show subtasks',
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
  label?: string;
}) {
  return (
    <div className="flex shrink-0 items-center gap-2 whitespace-nowrap px-2">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(value) => onCheckedChange(value === true)}
      />
      <Label htmlFor={id} className="cursor-pointer text-sm font-normal text-muted-foreground">
        {label}
      </Label>
    </div>
  );
}
